"use strict";
/**
 * Copyright Mitel. All Rights Reserved.
 * @license
 */
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Entry point for all public APIs of the package.
 * @module
 * @description
 */
var authentication_service_1 = require("./authentication-service");
exports.AuthenticationService = authentication_service_1.AuthenticationService;
var http_service_1 = require("./http-service");
exports.HttpService = http_service_1.HttpService;
//# sourceMappingURL=index.js.map